





































import {Vue, Component} from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class DocumentView extends Vue {
  mounted() {
    const rapidoc = document.getElementById('rapidoc')
    if (!rapidoc) {
      return
    }
    const shadowRoot = rapidoc.shadowRoot
    if (!shadowRoot) {
      return
    }

    const css = shadowRoot.querySelector("style")
    if (!css) {
      setTimeout(() => {
        const item = shadowRoot.querySelector("style")
        item!.textContent = item!.textContent + `
        .nav-scroll::-webkit-scrollbar-thumb {
          background-color: #E6E4E1 !important;
        }
        .m-btn {
          box-shadow: none !important;
        }
        .m-markdown a, .m-markdown-small a {
          color: #4C8825 !important;
        }
        #operations-top {
          padding: 1rem;
        }
        .tag.title {
          padding-top: 1rem;
        }
    `

      }, 1000)
      return
    }

  }
  get specUrl() {
    return `${process.env.BASE_URL}/docs/api_docs.yaml`
  }

}
